/**
 * Created by Suhel Shrestha on 6/4/19
 */

import { computed } from 'mobx';

export default class DaqLocationModel {
  id;
  store;

  constructor(store, daqLocation) {
    this.store = store;
    this.id = +daqLocation.id;
    this.source_location = daqLocation.source_location;
    this.destination_location = daqLocation.destination_location;
    this.user_name = daqLocation.user_name;
    this.user_password = daqLocation.user_password;
    this.interval = daqLocation.interval;
    this.port_no = daqLocation.port_no;
    this.certificate = daqLocation.certificate;
    this.mqtt_topic = daqLocation.mqtt_topic;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      source_location: this.source_location,
      destination_location: this.destination_location,
      user_name: this.user_name,
      user_password: this.user_password,
      interval: this.interval,
      port_no: this.port_no,
      certificate: this.certificate,
      mqtt_topic: this.mqtt_topic,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.source_location = json.source_location;
    this.destination_location = json.destination_location;
    this.user_name = json.user_name;
    this.user_password = json.user_password;
    this.interval = json.interval;
    this.port_no = json.port_no;
    this.certificate = json.certificate;
    this.mqtt_topic = json.mqtt_topic;
  }
}



// WEBPACK FOOTER //
// ./src/models/DaqLocationModel.js